import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const mobShare = () => {
    gsap.registerPlugin(ScrollTrigger);
    const boxes = gsap.utils.toArray('.stagger');
    boxes.forEach((box, i) => {
        const anim = gsap.fromTo(box, {
            autoAlpha: 0,
            y: 50,
        }, {
            duration: 1,
            autoAlpha: 1,
            y: 0,
            delay: 0.1 + (0.1 * i),
        });
        ScrollTrigger.create({
            trigger: box,
            animation: anim,
            toggleActions: 'play none none none',
            once: true,
        });
    });

    const shareMobBtn = document.querySelector('.social-share-block__title--mob');
    if(shareMobBtn){
        const shareBtnsList = document.querySelector('.social-share-block__list--mob');
        shareMobBtn.addEventListener('click', function (){
            shareBtnsList.classList.toggle('open');
        });
    }
}

export default mobShare;
